import React, { useReducer } from 'react';
import StateProvider, {
  useLegFilterState,
  useAvailableFilterState,
} from './StateProvider';
import PredicateProvider, { usePredicate } from './PredicateProvider';
import ActionsProvider, {
  reducer,
  useFilterActions,
  useLegFilterActions,
} from './ActionsProvider';
import SummaryProvider, {
  useAppliedFilter,
  useUnsuitedFilter,
  useFilterChanges,
  useFilterSummary,
} from './SummaryProvider';

const CarrierFilterProvider = ({ children }) => {
  const [carriers, dispatch] = useReducer(reducer, null);

  return (
    <StateProvider carriers={carriers}>
      <PredicateProvider>
        <ActionsProvider dispatch={dispatch}>
          <SummaryProvider>{children}</SummaryProvider>
        </ActionsProvider>
      </PredicateProvider>
    </StateProvider>
  );
};

export {
  useLegFilterState as useCarrierLegFilterState,
  useAvailableFilterState as useAvailableCarriers,
  useFilterActions as useCarrierFilterActions,
  usePredicate as useCarrierFilterPredicate,
  useAppliedFilter as useAppliedCarrierFilter,
  useUnsuitedFilter as useUnsuitedCarrierFilter,
  useFilterSummary as useCarrierFilterSummary,
  useLegFilterActions as useCarrierLegFilterActions,
  useFilterChanges as useCarrierFilterChanges,
};

export default CarrierFilterProvider;
